<template>
  <section id="contact-1388">
    <div class="cs-container">
      <div class="cs-content">
        <h2 class="cs-title">Join our Team</h2>
        <p class="cs-text">
          We are a team of compassionate and dedicated professionals committed to delivering personalized, high-quality, and empowering disability support services that enhance independence and well-being.
        </p>
        <ul class="cs-ul">
          <li v-for="contact in contacts" :key="contact.header" class="cs-li">
            <picture class="cs-icon-wrapper">
              <img aria-hidden="true" :src="contact.icon" :alt="contact.alt" class="cs-icon" width="40" height="40" decoding="async">
            </picture>
            <div class="cs-flex-group">
              <span class="cs-header">{{ contact.header }}</span>
              <a v-for="(link, index) in contact.links" :key="index" :href="link.href" class="cs-link">{{ link.text }}</a>
            </div>
          </li>
        </ul>
      </div>
      <!--Form-->
      <form class="cs-form" @submit.prevent="submitForm">
        <h3 class="cs-h3">Contact Us</h3>
        <label class="cs-label">
          Name
          <input v-model="form.name" class="cs-input" required type="text" name="name" placeholder="Name">
        </label>
        <label class="cs-label cs-email">
          Email
          <input v-model="form.email" class="cs-input" required type="email" name="email" placeholder="Email">
        </label>
        <label class="cs-label cs-phone">
          Phone
          <input v-model="form.phone" class="cs-input" required type="tel" name="phone" placeholder="Phone">
        </label>
        <label class="cs-label">
          Availability
          <textarea v-model="form.message" class="cs-input cs-textarea" required name="message" placeholder="Share availability..."></textarea>
        </label>
        <button class="cs-button-solid cs-submit" type="submit" :disabled="loading">{{ loading ? 'Sending...' : 'Send Message' }}</button>
        <p v-if="successMessage" class="cs-success">{{ successMessage }}</p>
        <p v-if="errorMessage" class="cs-error">{{ errorMessage }}</p>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  name: "ContactForm",
  data() {
    return {
      contacts: [
        {
          header: "Phone",
          icon: "https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/phone-76.svg",
          alt: "phone icon",
          links: [
            { text: "+61-424232426", href: "tel:+61-424232426" },
          ]
        },
        {
          header: "Email",
          icon: "https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/mail-76.svg",
          alt: "email icon",
          links: [{ text: "info@ajonee.com.au", href: "mailto:info@ajonee.com.au" }]
        },
        {
          header: "Locations",
          icon: "https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/pin-76.svg",
          alt: "address icon",
          links: [
            { text: "Perth, Western Australia", href: "#" }
          ]
        }
      ],
      form: {
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Career"
      },
      loading: false,
      successMessage: "",
      errorMessage: ""
    };
  },
  methods: {
    async submitForm() {
      this.loading = true;
      this.successMessage = "";
      this.errorMessage = "";
      
      try {
        const response = await fetch("https://ajonee.com.au/api/sendEmail", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(this.form)
        });
        
        if (response.ok) {
          this.successMessage = "Your message has been sent successfully!";
          this.form = { name: "", email: "", phone: "", message: "", type: "Career" };
        } else {
          this.errorMessage = "Failed to send message. Please try again.";
        }
      } catch (error) {
        this.errorMessage = "An error occurred. Please check your network and try again.";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>

/*-- -------------------------- -->
<---          Contact           -->
<--- -------------------------- -*/

/* Mobile - 360px */
@media only screen and (min-width: 0rem) {
#contact-1388 {
    padding: var(--sectionPadding);
    background-color: #f7f7f7;
    position: relative;
    z-index: 1;
}
#contact-1388 .cs-container {
    width: 100%;
    /* changes to 1280px at tablet */
    max-width: 36.5rem;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;
    column-gap: auto;
    /* 48px - 64px */
    gap: clamp(2rem, 3vw, 3rem);
    position: relative;
}
#contact-1388 .cs-content {
    /* set text align to left if content needs to be left aligned */
    text-align: left;
    width: 100%;
    display: flex;
    flex-direction: column;
    /* centers content horizontally, set to flex-start to left align */
    align-items: flex-start;
}

#contact-1388 .cs-title {
    max-width: 23ch;
}
#contact-1388 .cs-text {
    margin-bottom: 1rem;
}
#contact-1388 .cs-text:last-of-type {
    margin-bottom: 2rem;
}
#contact-1388 .cs-ul {
    text-align: left;
    width: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.5rem;
    position: relative;
}
#contact-1388 .cs-li {
    list-style: none;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 1.25rem;
}
#contact-1388 .cs-li:hover .cs-icon-wrapper {
    transform: scale(1.1);
}
#contact-1388 .cs-header {
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.2em;
    margin-bottom: 0.75rem;
    color: var(--headerColor);
    display: block;
}
#contact-1388 .cs-link {
    font-size: 1rem;
    line-height: 1.5em;
    text-decoration: none;
    color: #767676;
    display: block;
    position: relative;
}
#contact-1388 .cs-link:hover {
    text-decoration: underline;
}
#contact-1388 .cs-icon-wrapper {
    width: 3.75rem;
    height: 3.75rem;
    margin: 0;
    border-radius: 50%;
    border: 1px solid #bababa;
    display: flex;
    justify-content: center;
    align-items: center;
    /* prevents flexbox from squishing it */
    flex: none;
    transition: transform 0.3s;
}
#contact-1388 .cs-icon {
    width: 1.5rem;
    height: auto;
    display: block;
}
#contact-1388 .cs-form {
    width: 100%;
    max-width: 39.375rem;
    /* 24px - 48px top and bottom */
    /* 16px - 48px left and right */
    padding: clamp(1.5rem, 5.18vw, 3rem) clamp(1rem, 4vw, 3rem);
    /* prevents flexbox from affecting height and width */
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 1rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.75rem;
}
#contact-1388 .cs-h3 {
    /* 20px - 39px */
    font-size: clamp(1.25rem, 3vw, 2.4375rem);
    line-height: 1.2em;
    font-weight: 700;
    margin: 0 0 0.25rem 0;
    color: var(--headerColor);
}
#contact-1388 .cs-label {
    /* 14px - 16px */
    font-size: clamp(0.875rem, 1.5vw, 1rem);
    width: 100%;
    color: var(--headerColor);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 0.25rem;
}
#contact-1388 .cs-input {
    font-size: 1rem;
    width: 100%;
    height: 3.5rem;
    padding: 0;
    padding-left: 1.5rem;
    color: var(--headerColor);
    background-color: #f7f7f7;
    border-radius: 0.5rem;
    border: none;
    /* prevents padding from adding to height and width */
    box-sizing: border-box;
}
#contact-1388 .cs-input::placeholder {
    color: #7d799c;
    opacity: 0.6;
}
#contact-1388 .cs-textarea {
    min-height: 7.5rem;
    padding-top: 1.5rem;
    margin-bottom: 0.75rem;
    font-family: inherit;
}
#contact-1388 .cs-button-solid {
    font-size: 1rem;
    line-height: 3.5rem;
    text-decoration: none;
    font-weight: 700;
    overflow: hidden;
    margin: 0;
    color: #fff;
    padding: 0 3rem;
    border-radius: 1.875rem;
    background-color: var(--primary);
    display: inline-block;
    position: relative;
    z-index: 1;
    transition: color 0.3s;
}
#contact-1388 .cs-button-solid:before {
    content: "";
    position: absolute;
    display: block;
    height: 100%;
    width: 0%;
    background: #1a1a1a;
    opacity: 1;
    top: 0;
    left: 0;
    z-index: -1;
    transition: width 0.3s;
}
#contact-1388 .cs-button-solid:hover {
    color: var(--primary);
}
#contact-1388 .cs-button-solid:hover:before {
    width: 100%;
}
#contact-1388 .cs-submit {
    width: 100%;
    min-width: 12.5rem;
    border: none;
}
#contact-1388 .cs-submit:hover {
    color: #fff;
    cursor: pointer;
}
}
/* Tablet - 768px */
@media only screen and (min-width: 48rem) {
#contact-1388 .cs-container {
    max-width: 80rem;
    flex-direction: row;
    justify-content: space-between;
}
#contact-1388 .cs-content {
    width: 47%;
    /* prevents flexbox from squishing it */
    flex: none;
}
#contact-1388 .cs-submit {
    width: auto;
}
}
/* Desktop - 1024px */
@media only screen and (min-width: 64rem) {
#contact-1388 .cs-form {
    width: 46%;
    max-width: 36.125rem;
}
#contact-1388 .cs-submit {
    width: auto;
}
}
/* Large Desktop - 1500px */
@media only screen and (min-width: 93.75rem) {
#contact-1388 .cs-graphic {
    display: block;
}
}

</style>